/**
 * Loads the Drive Search React widget from the configured search API
 * and mounts it into [data-sdd-search-root] nodes (header + blocks).
 */
(function () {
  function showError(mount, message) {
    mount.innerHTML =
      '<p class="sdd-search-block__error">' + message + "</p>";
  }

  function loadCss(href) {
    if (document.querySelector('link[data-sdd-widget="' + href + '"]')) {
      return Promise.resolve();
    }
    return fetch(href)
      .then(function (res) {
        if (!res.ok) throw new Error("CSS HTTP " + res.status);
        return res.text();
      })
      .then(function (css) {
        var style = document.createElement("style");
        style.setAttribute("data-sdd-widget", href);
        style.textContent = css;
        document.head.appendChild(style);
      });
  }

  function loadScript(src) {
    if (window.SDDSearch) return Promise.resolve();
    return fetch(src)
      .then(function (res) {
        if (!res.ok) throw new Error("JS HTTP " + res.status);
        return res.text();
      })
      .then(function (js) {
        var blob = new Blob([js], { type: "text/javascript" });
        var url = URL.createObjectURL(blob);
        return new Promise(function (resolve, reject) {
          var script = document.createElement("script");
          script.src = url;
          script.onload = function () {
            URL.revokeObjectURL(url);
            resolve();
          };
          script.onerror = function () {
            URL.revokeObjectURL(url);
            reject(new Error("Failed to execute search widget script"));
          };
          document.head.appendChild(script);
        });
      });
  }

  function boot(root) {
    if (!root || root.getAttribute("data-sdd-booted") === "1") return;
    root.setAttribute("data-sdd-booted", "1");

    var apiBase = (root.getAttribute("data-api-base") || "").replace(/\/$/, "");
    var placeholder = root.getAttribute("data-placeholder") || "";
    var mount = root.querySelector("[data-sdd-mount]");
    if (!mount) return;

    if (!apiBase) {
      showError(
        mount,
        "Set Drive Search API URL in Theme settings → Header → Search."
      );
      return;
    }

    Promise.all([
      loadCss(apiBase + "/widget/sdd-search.css"),
      loadScript(apiBase + "/widget/sdd-search.js"),
    ])
      .then(function () {
        if (!window.SDDSearch || typeof window.SDDSearch.mount !== "function") {
          throw new Error("Search widget loaded but SDDSearch.mount is missing");
        }
        window.SDDSearch.mount(mount, {
          apiBase: apiBase,
          placeholder: placeholder || undefined,
        });
      })
      .catch(function (err) {
        showError(
          mount,
          "Could not load search from " +
            apiBase +
            " (" +
            (err && err.message ? err.message : "unknown error") +
            ")."
        );
      });
  }

  function bootAll() {
    document.querySelectorAll("[data-sdd-search-root]").forEach(boot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }

  document.addEventListener("shopify:section:load", bootAll);
})();
